import React from 'react';

export default function TimeLine({ data }) {

    const scrollLeft = () => {
        document.getElementById('scrollableDiv').scrollBy({
            left: -300, // 调整滚动距离
            behavior: 'smooth'
        });
    }

    const scrollRight = () => {
        document.getElementById('scrollableDiv').scrollBy({
            left: 300, // 调整滚动距离
            behavior: 'smooth'
        });
    }

    return (
        <section className="py-16 sm:py-24 min-h-[400px] sm:min-h-[600px]" style={{ backgroundImage: "url(" + data.bg + ")", backgroundSize: "cover", backgroundPosition: "center" }}>
            <div className="relative w-full mx-auto">
                {/* 顶部标题 */}
                <div className="pt-1 sm:pt-8 max-w-2xl mx-auto text-center space-y-3 px-4 md:px-0">
                    <h3 className="text-gray-50 font-semibold text-3xl sm:text-4xl xl:text-5xl">
                        {data.title}
                    </h3>
                    <p className="mt-3 text-gray-100 text-sm sm:text-base">{data.subTitle}</p>
                </div>


                {/* 时间线 + 按钮 */}
                <div className="pt-2 sm:pt-10 pb-16 w-full">
                    {/* ✅ 包裹区域，统一宽度和 Hero1 对齐 */}
                    <div className="relative w-full px-4 lg:w-[70%] lg:max-w-[1440px] mx-auto flex items-center">
                        {/* 左箭头 */}
                        <button
                            onClick={scrollLeft}
                            className="hidden lg:flex items-center justify-center absolute -left-10 z-10 bg-blue-400 hover:bg-blue-300 active:bg-blue-200 text-gray-300 rounded-full p-2"
                            style={{ top: '50%', transform: 'translate(-50%, calc(-50% - 30px))' }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                            </svg>
                        </button>

                        {/* 时间线 scrollable 容器 */}
                        <div className="relative w-full">
                            {/* 左遮罩提示 */}
                            <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-[#bfdbfe44] to-transparent pointer-events-none block md:hidden z-10"></div>
                            {/* 右遮罩提示 */}
                            <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-[#bfdbfe44] to-transparent pointer-events-none block md:hidden z-10"></div>

                            <div
                                id="scrollableDiv"
                                className="text-gray-100 pl-6 pr-6 w-full overflow-x-auto no-scrollbar flex"
                            >
                                <ol className="relative flex min-w-max md:min-w-[2000px] mt-12 justify-between items-start">
                                    {data.items &&
                                        data.items.map((item, idx) => (
                                            <li key={idx} className="relative flex flex-col items-center px-6 z-10">
                                                {/* 时间、节点、卡片...（原样保留） */}

                                                {/* 时间：绿色标签在上方 */}
                                                <div className="mb-8 sm:mb-16">
                                                    <span
                                                        className={`text-lg sm:text-2xl font-normal px-3 py-1 rounded-full whitespace-nowrap
    ${idx === 0 ? 'bg-green-500 text-white' : 'bg-transparent text-gray-100 px-0 py-0 rounded-none'}`}
                                                    >
                                                        {item.time}
                                                    </span>
                                                </div>

                                                {/* 节点圆点（覆盖在横轴上） */}
                                                <div className="relative flex items-center mb-4">
                                                    {/* 左边延伸白线 */}
                                                    <div className="absolute left-[-160px] w-40 h-1 bg-white z-0"></div>
                                                    {/* 圆点 */}
                                                    <div className={`w-6 h-6 rounded-full border-4 border-white z-10 ${idx === 0 ? 'bg-green-500' : 'bg-blue-500'}`}></div>
                                                    <div className="absolute right-[-160px] w-40 h-1 bg-white z-0"></div>
                                                </div>

                                                {/* 竖线：连接横轴到底部卡片 */}
                                                <div className="w-1 h-12 bg-white mt-[-16px]" />

                                                {/* 内容卡片：白色背景，放 title/desc */}
                                                <div className="bg-white text-gray-800 rounded-xl shadow-lg px-2 py-2 sm:px-4 sm:py-3 text-left w-56 h-32 sm:w-72 sm:h-40 flex flex-col justify-start">
                                                    <h4 className="text-lg sm:text-xl font-normal mt-2 sm:mt-3">{item.title}</h4>
                                                    {item.desc && <p className="text-sm sm:text-base mt-2 sm:mt-4 text-gray-600">{item.desc}</p>}
                                                </div>
                                            </li>


                                        ))}
                                </ol>
                            </div>

                            {/* 右箭头 */}
                            <button
                                onClick={scrollRight}
                                className="hidden lg:flex items-center justify-center absolute -right-10 z-10 bg-white hover:bg-gray-100 active:bg-gray-200 text-blue-600 rounded-full p-2"
                                style={{ top: '50%', transform: 'translate(50%, calc(-50% - 30px))' }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2.5"
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}